exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".my-scroller .pull-to-refresh-layer .spinner-holder{visibility:hidden}.my-scroller .pull-to-refresh-layer{background-image:url(http://qianka.b0.upaiyun.com/images/4f013b6bc7d96fc347f416ad3673f937.png);background-repeat:no-repeat;background-position:50%;background-size:40px 40px;opacity:0;-webkit-transform:scale(1);transform:scale(1);transition:all .15s linear;-webkit-transition:all .15s linear}.my-scroller .pull-to-refresh-layer.active{-webkit-transform:scale(1.35);transform:scale(1.35);opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-7fe17ee4","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./demo/components/Custom.vue
// module id = 38
// module chunks = 0